import { defineStore } from 'pinia';
import api from '@/api';

export const useStepExecutionStore = defineStore('stepExecution', {
  state: () => ({
    queue: [],
    history: [],
    loading: false,
    error: null
  }),

  getters: {
    getQueue: (state) => state.queue,
    getHistory: (state) => state.history,
    isLoading: (state) => state.loading
  },

  actions: {
    async fetchQueue(stationTypeId) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.stepExecution.getQueue(stationTypeId);
        this.queue = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    // Everything available across ALL of the operator's assigned stations,
    // same endpoint the mobile app uses for its home screen queue - the web
    // console used to only ever call the single-station-type getQueue,
    // requiring a station to be picked before any task showed at all.
    async fetchMyQueue() {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.stepExecution.getMyQueue();
        this.queue = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async startStep(wipItemId, data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.stepExecution.startStep(wipItemId, data);
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async completeStep(executionId, data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.stepExecution.completeStep(executionId, data);
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async fetchHistory(wipItemId) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.stepExecution.getHistory(wipItemId);
        this.history = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    clearQueue() {
      this.queue = [];
    }
  }
});
